import { RefObject, useCallback, useEffect, useState } from "react";
import { observarRedimensionamento } from "../../../../utils/observarRedimensionamento";
import { zoomEfetivo } from "../../../../utils/zoomEfetivo";

const useMedida = (elemento: HTMLElement | null, medida: "width" | "height"): number => {
  const [valor, setValor] = useState(0);

  useEffect(() => {
    if (!elemento) {
      return undefined;
    }
    const medir = () => setValor(Math.floor(elemento.getBoundingClientRect()[medida] / zoomEfetivo(elemento)));
    medir();
    return observarRedimensionamento(elemento, medir);
  }, [elemento, medida]);

  return valor;
};

export const useLarguraElemento = (ref: RefObject<HTMLElement>): number => {
  const [elemento, setElemento] = useState<HTMLElement | null>(null);
  useEffect(() => setElemento(ref.current), [ref]);
  return useMedida(elemento, "width");
};

export const useMedidasElemento = () => {
  const [elemento, setElemento] = useState<HTMLElement | null>(null);
  const referencia = useCallback((no: HTMLElement | null) => setElemento(no), []);
  return { referencia, altura: useMedida(elemento, "height"), largura: useMedida(elemento, "width") };
};

export default useLarguraElemento;
